module.exports = __webpack_public_path__ + "img/rectangle-wide.b282309c.svg";